<template>
    <div class="single-contact-import">
        <h3>Kişi Ekle</h3>

        <div class="platform-selection" v-if="!skipPlatformSelection">
            <div class="form-group">
                <label>Platform</label>
                <a-select v-model="selectedPlatform" style="width: 100%">
                    <a-select-option value="supsis">Supsis</a-select-option>
                    <a-select-option value="mail">Mail</a-select-option>
                    <a-select-option value="whatsapp">Whatsapp</a-select-option>
                </a-select>
            </div>

            <div class="form-group" v-if="selectedPlatform === 'whatsapp' && whatsappChannels.length > 0">
                <label>Kanal</label>
                <a-select v-model="selectedChannels" style="width: 100%" mode="multiple">
                    <a-select-option v-for="channel in whatsappChannels" :key="channel._id" :value="channel._id">
                        {{ channel.name }}
                    </a-select-option>
                </a-select>
            </div>
        </div>

        <a-divider />

        <div class="contact-form">
            <div class="form-row">
                <div class="form-group">
                    <label>Ad Soyad <span class="required">*</span></label>
                    <a-input v-model="contact.name" placeholder="Ad Soyad giriniz" />
                </div>

                <div class="form-group">
                    <label>E-posta</label>
                    <a-input v-model="contact.email" placeholder="E-posta giriniz" />
                </div>
            </div>

            <div class="form-group">
                <label>Telefon</label>
                <a-input v-model="contact.phone" placeholder="Telefon giriniz" />
            </div>

            <a-divider v-if="contactProperties.length > 0" />

            <template v-if="contactProperties.length > 0">
                <h4>Özel Alanlar</h4>

                <div class="form-row-fields">
                    <div class="form-group custom-field" v-for="property in contactProperties" :key="property._id">
                        <label>{{ property.label }}</label>

                        <a-input
                            v-if="property.type === 'text' || property.type === 'string'"
                            v-model="customFields[property.name]"
                            placeholder="Değer giriniz"
                        />

                        <a-date-picker
                            v-else-if="property.type === 'date'"
                            v-model="customFields[property.name]"
                            style="width: 100%"
                        />

                        <a-select
                            v-else-if="property.type === 'select'"
                            v-model="customFields[property.name]"
                            style="width: 100%"
                        >
                            <a-select-option
                                v-for="option in property.options"
                                :key="option.value"
                                :value="option.value"
                            >
                                {{ option.label }}
                            </a-select-option>
                        </a-select>

                        <a-input v-else v-model="customFields[property.name]" placeholder="Değer giriniz" />
                    </div>
                </div>
            </template>
        </div>

        <div class="form-actions">
            <a-button @click="onCancelled">İptal</a-button>
            <a-button type="primary" @click="addContact" :loading="loading" :disabled="!isFormValid">
                Kişi Ekle
            </a-button>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "SingleContactImport",
    props: {
        onCompleted: {
            type: Function,
            required: true,
        },
        onCancelled: {
            type: Function,
            required: true,
        },
        skipPlatformSelection: {
            type: Boolean,
            default: false,
        },
        defaultPlatform: {
            type: String,
            default: "supsis",
        },
    },
    data() {
        return {
            loading: false,
            selectedPlatform: this.defaultPlatform || "supsis",
            selectedChannels: [],
            contact: {
                name: "",
                email: "",
                phone: "",
            },
            customFields: {},
        };
    },
    computed: {
        ...mapState({
            contactProperties: (state) => state.contactProperty.data,
            channels: (state) => state.channel.channels,
            siteId: (state) => state.auth.site._id,
        }),
        whatsappChannels() {
            return this.channels.filter(
                (channel) =>
                    channel.type === "whatsapp-qr" || channel.type === "whatsapp-v2" || channel.type === "whatsapp-unipile"
                    || channel.type === "whatsapp-business-api" || channel.type === "whatsapp-business-api-supsis"
            );
        },
        isFormValid() {
            return this.contact.name && (this.selectedPlatform !== "whatsapp" || this.selectedChannels.length > 0);
        },
    },
    created() {
        if (this.selectedPlatform === "whatsapp" && !this.selectedChannels.length && this.whatsappChannels.length > 0) {
            this.selectedChannels = [this.whatsappChannels[0]._id];
        }
    },
    methods: {
        clearPhoneNumber(text) {
            return (text || "").toString().replace(/[^0-9]/g, "");
        },
        addContact() {
            if (!this.isFormValid) {
                return;
            }

            this.loading = true;

            const payload = {
                fullname: this.contact.name,
                email: this.contact.email,
                phone: this.clearPhoneNumber(this.contact.phone),
                platform: this.selectedPlatform,
                channelIds: this.selectedChannels,
                contactProperties: this.customFields,
            };

            this.$emit("addContact", payload);
            this.loading = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.single-contact-import {
    width: 100%;
    margin: 0 auto;
    padding: 5px;
    max-width: 650px;

    h3 {
        margin-bottom: 20px;
    }

    h4 {
        margin-bottom: 15px;
    }

    .form-row {
        display: flex;
        gap: 15px;
        width: 100%;

        .form-group {
            flex: 1;
        }
    }

    .form-row-fields {
        display: flex;
        flex-wrap: wrap;
        gap: 15px;

        .custom-field {
            flex: 0 0 calc(50% - 8px);

            @media (max-width: 600px) {
                flex: 0 0 100%;
            }
        }
    }

    .form-group {
        margin-bottom: 15px;

        label {
            display: block;
            margin-bottom: 8px;
            font-weight: 500;

            .required {
                color: #f5222d;
            }
        }
    }

    .platform-selection {
        margin-bottom: 20px;
    }

    .contact-form {
        margin-bottom: 20px;
    }

    .form-actions {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        margin-top: 20px;
    }
}
</style>
